import { LAYOUT } from '../constants'

/**
 * @type {import('vue-router').RouteConfig[]}
 */
export default [
    {
        path: '/alumniContact',
        component: LAYOUT,
        redirect: '/alumniContact/index/1',
        meta: { title: '校友联络', showNavPanel: false, },
        props: (route) => ({ type: 1, ...route.params }),
        children: [
            {
                path: 'index/:type',
                name: '地区联络',
                component: () => import('@/views/alumniContact/index.vue'),
                props: (route) => ({ type: 1, ...route.params }),
                meta: { title: '地区联络', type: 1 },
            },
            {
                path: 'index/2',
                name: '年级联络',
                component: () => import('@/views/alumniContact/index.vue'),
                props: (route) => ({ type: 2, ...route.params }),
                meta: { title: '年级联络', type: 2 },
            },
            {
                path: 'index/3',
                name: '院系校友工作',
                component: () => import('@/views/alumniContact/index.vue'),
                props: (route) => ({ type: 3, ...route.params }),
                meta: { title: '院系校友工作', type: 3 },
            },
            {
                path: 'index/4',
                name: '专业委员会',
                component: () => import('@/views/alumniContact/index.vue'),
                props: (route) => ({ type: 4, ...route.params }),
                meta: { title: '专业委员会', type: 4 },
            },
            {
                path: 'index/5',
                name: '兴趣群体',
                component: () => import('@/views/alumniContact/index.vue'),
                props: (route) => ({ type: 5, ...route.params }),
                meta: { title: '兴趣群体', type: 5 },
            },
            {
                path: 'detail',
                name: '校友联络详情',
                component: () => import('@/views/alumniContact/detail.vue'),
                meta: { title: '校友联络详情', hide: true },
            },
        ],
    },
]
